import { render } from "./CallLink.vue?vue&type=template&id=b278a6ec&scoped=true"
import script from "./CallLink.vue?vue&type=script&lang=js"
export * from "./CallLink.vue?vue&type=script&lang=js"

import "./CallLink.vue?vue&type=style&index=0&id=b278a6ec&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b278a6ec"

export default script